import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ActionMenu from '../../../../components/action-menu';
import { USER_ROLES } from '../../../../utils/constants';
import { UserRolesPropType } from '../../../../utils/prop-types';
import { activateSite, deactivateSite } from '../../../../redux/sites';

const SiteActionMenu = ({ site, role, getSitesFunc }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleEditSite = useCallback(() => {
        navigate(`/dashboard/sites/${site.id}`);
    }, [site]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleActivateSite = useCallback(() => {
        dispatch(activateSite({ siteId: site.id, onSuccess: getSitesFunc }));
    }, [dispatch, site.id, getSitesFunc]);

    const handleDeactivateSite = useCallback(() => {
        dispatch(deactivateSite({ siteId: site.id, onSuccess: getSitesFunc }));
    }, [dispatch, site.id, getSitesFunc]);

    const actions = [{ label: 'Edit', onClick: handleEditSite }];

    // Add active/inactive actions for users who can manage sites
    if ([USER_ROLES.admin.value, USER_ROLES.testCoordinator.value, USER_ROLES.orgAdmin.value].includes(role)) {
        if (site.deletedAt) {
            actions.push({ label: 'Make Active', onClick: handleActivateSite });
        } else {
            actions.push({ label: 'Make Inactive', onClick: handleDeactivateSite });
        }
    }

    return (
        <ActionMenu
            id={`${site.id}-actions`}
            defaultAction={{
                label: 'Edit',
                onClick: handleEditSite,
            }}
            actions={actions}
        />
    );
};

SiteActionMenu.propTypes = {
    site: PropTypes.shape({
        id: PropTypes.number,
        deletedAt: PropTypes.string,
    }).isRequired,
    role: UserRolesPropType.isRequired,
    getSitesFunc: PropTypes.func,
};

SiteActionMenu.defaultProps = {
    getSitesFunc: () => {},
};

export default SiteActionMenu;
